<profile-title *ngIf="profile?.resume" [profile]="profile" [loading]="loading?.TITLE"></profile-title>

<profile-hard-skills
  *ngIf="profile?.hardSkills.length"
  [profile]="profile"
  [loading]="loading?.HARD_SKILLS"
></profile-hard-skills>

<profile-pro-experiences
  *ngIf="profile?.proExperiences.length"
  [model]="profile?.proExperiences"
></profile-pro-experiences>

<profile-educations *ngIf="profile?.educations.length" [model]="profile?.educations"></profile-educations>

<profile-soft-skills *ngIf="profile?.softSkills.length" [profile]="profile"></profile-soft-skills>

<profile-languages
  *ngIf="profile?.languages.length"
  [model]="profile?.languages"
  [loading]="loading?.LANGUAGES"
></profile-languages>

<profile-extra-experiences
  *ngIf="profile?.extraExperiences.length"
  [model]="profile?.extraExperiences"
></profile-extra-experiences>

<profile-wishes *ngIf="profile?.wishes.length" [model]="profile?.wishes"></profile-wishes>

<profile-links *ngIf="profile?.links.length" [model]="profile?.links"></profile-links>
